import { render, staticRenderFns } from "./purchaseRequisition.vue?vue&type=template&id=70950b7b&scoped=true"
import script from "./purchaseRequisition.vue?vue&type=script&lang=js"
export * from "./purchaseRequisition.vue?vue&type=script&lang=js"
import style0 from "./purchaseRequisition.vue?vue&type=style&index=0&id=70950b7b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70950b7b",
  null
  
)

export default component.exports